import { deepKeysToCamel } from '@eventbrite/transformation-utils';
import { $FixMe } from '@eventbrite/ts-utils';
import { fetchSearchEventExpansions } from '../api/expansions';
import { updateContent } from './content';

export const addExpansionsToEventEntities = (
    entities: $FixMe,
    response: any,
) => {
    const eventIds = Object.keys(entities);
    const { events } = response;

    return eventIds.reduce((prev, eventId) => {
        let expandedEventEntity = {
            ...entities[eventId],
        };

        const expandedEvent = events.find(
            ({ id }: { id: string }) => id === eventId,
        );

        let series;
        let eventSalesStatus;
        let ticketAvailability;
        let primaryOrganizer;
        let publicCollections;
        let saves;

        if (expandedEvent) {
            series = expandedEvent.series;
            eventSalesStatus = expandedEvent.event_sales_status;
            ticketAvailability = expandedEvent.ticket_availability;
            primaryOrganizer = expandedEvent.primary_organizer;
            publicCollections = expandedEvent.public_collections;
            saves = expandedEvent.saves;
        }

        if (series) {
            expandedEventEntity = {
                ...expandedEventEntity,
                series: deepKeysToCamel(series),
            };
        }

        if (eventSalesStatus) {
            expandedEventEntity = {
                ...expandedEventEntity,
                eventSalesStatus: deepKeysToCamel(eventSalesStatus),
            };
        }

        if (ticketAvailability) {
            expandedEventEntity = {
                ...expandedEventEntity,
                ticketAvailability: deepKeysToCamel(ticketAvailability),
            };
        }

        if (primaryOrganizer) {
            expandedEventEntity = {
                ...expandedEventEntity,
                primaryOrganizer: deepKeysToCamel(primaryOrganizer),
            };
        }

        if (publicCollections) {
            expandedEventEntity = {
                ...expandedEventEntity,
                publicCollections: deepKeysToCamel(publicCollections),
            };
        }

        if (saves) {
            expandedEventEntity = {
                ...expandedEventEntity,
                saves: deepKeysToCamel(saves),
            };
        }

        return {
            ...prev,
            [eventId]: expandedEventEntity,
        };
    }, {});
};

export const updateEventsWithExpansions =
    (response: any) => (dispatch: Function, getState: Function) => {
        const {
            content: { entities, entityContext },
            pagination,
            search,
        } = getState();

        const entitiesWithExpansionsAdded = addExpansionsToEventEntities(
            entities,
            response,
        );

        dispatch(
            updateContent({
                entities: entitiesWithExpansionsAdded,
                entityContext,
                pagination,
                searchCriterias: { ...search },
            }),
        );
    };

// The intent here is to manually apply expansions on the events in the store.
// This only applies to the initial server render.
// When we call the search endpoint from the user searching
// in the app, we already get the expansions.
// Skipping the expansions on the server is a performance optimization.
export const getEventExpansions =
    () => (dispatch: Function, getState: Function) => {
        const {
            content: { entities },
        } = getState();

        const eventIdsInStore = Object.keys(entities);

        if (eventIdsInStore.length) {
            fetchSearchEventExpansions(eventIdsInStore)
                .then((response: any) => {
                    // Take the event entities from the Redux store,
                    // and then add the expanded information to them.
                    dispatch(updateEventsWithExpansions(response));
                })
                .catch(() => {
                    //do nothing. This is just extra hydration of event
                    //data. And if it fails it should do so silently.
                });
        }
    };
